import { useEffect, useState } from "react";
import { Routes, Route } from "react-router-dom";
import AppBar from "./components/global/AppBar";
import SideBar from "./components/global/SideBar";
import Subscriber from "./pages/AdminModule/Subscriber";
import Dashboard from "./pages/AdminModule/Dashboard";
import Query from "./pages/AdminModule/Query";
import FAQ from "./pages/AdminModule/FAQ";
import Plans from "./pages/AdminModule/Plan";
import EditProfile from "./pages/AdminModule/EditProfile.js";
import Profile from "./pages/AdminModule/Profile";
import Error404 from "./pages/Error404.js";
import secureLocalStorage from "react-secure-storage";

function AdminModule() {
  const [role, setRole] = useState(null);

  useEffect(() => {
    const adminRole = secureLocalStorage.getItem("role");
    console.log("Role", adminRole);
    if (adminRole != null) {
      setRole(adminRole);
    } else if (adminRole == undefined) {
      console.log("Here");
      setRole(null);
    }
  }, []);
  return (
    <div className="app">
      {role === "admin" ? <SideBar /> : null}

      <main className="content">
        {role === "admin" ? <AppBar /> : null}
        <Routes>
          <Route index element={<Dashboard role={role} />} />
          <Route path="/subscribers" element={<Subscriber role={role} />} />
          <Route path="/queries" element={<Query role={role} />} />
          <Route path="/faqs" element={<FAQ role={role} />} />
          <Route path="/plans" element={<Plans role={role} />} />
          <Route path="/view/profile" element={<Profile role={role} />} />
          <Route path="/edit/profile" element={<EditProfile role={role} />} />
          <Route path="*" element={<Error404 />} />
        </Routes>
      </main>
    </div>
  );
}

export default AdminModule;
